import { AppContext } from 'Api/AppContext';
import { injectTypes as injectTypesApi } from 'Api/Plugins/Orano';
import { DPPrestationTypes, DPPriorities, GroupeEquipement, Rgf, RgfWithGroupeEquipements, WRHeaderCreate, WRHeaderList } from 'Api/Plugins/Orano/Dtos';
import { IGmaoService } from 'Api/Plugins/Orano/Interfaces';
import { LocalizerService } from 'Api/Services';
import OranoCreateDPDialog from 'App/Areas/Explore/Dialogs/OranoCreateDPDialog.vue';
import { injectTypes } from 'App/injectTypes';
import { lazyInject } from 'App/Inversify.config';
import { BaseDialogBehavior } from 'App/Services/DialogService/BaseDialogBehavior';
import { DialogResult } from 'Framework/Components/ModalDialog/ModalDialog';
import { Component } from 'Framework/Components/UIElement';
import { IDialogService } from 'Framework/Services/IDialogService';
import { DataTableHeader } from 'vuetify';

interface IOranoState {
    unit: string;
    ecode: string;
}

@Component({
    name: 'OranoEquipmentDialog'
})
export default class OranoEquipmentDialog extends BaseDialogBehavior<IOranoState> {
    public formatDate(date: Date | string): string {
        if (typeof (date) === 'string') {
            date = new Date(date);
        }

        return this._localizerService.localizeDate(date).format('LL');
    }

    public getRgfUri(equipment: Rgf): string {
        return `https://xfrdcnoas18/as/ui/#as-currentpage-view?view=PassPortTIMD030&keydata=${equipment.site}${equipment.id_equipement_revision.trim()}+`
    }

    public async onOpenNewDemandePrestationAsync(): Promise<void> {
        const dataContextCreateDemand: { ecode: string, result: WRHeaderCreate } = {
            ecode: this._dataContext.ecode,
            result: null
        };

        const dialogResult = await this._dialogService.openAsync(
            'Explore',
            OranoCreateDPDialog,
            dataContextCreateDemand,

            {
                width: this._appContext.settings.dialogs.medium.width,
                height: this._appContext.settings.dialogs.auto.height,
            }
        );

        if (dialogResult == DialogResult.OK) {
            this.demandePrestations.push(Object.assign(dataContextCreateDemand.result, {
                WoReqDateEnter: dataContextCreateDemand.result.WoReqNeedDate,
                WoReqTimeEnter: dataContextCreateDemand.result.WoReqNeedTime
            }));
        }
    }

    protected async _onDataContextChanged(newValue: IOranoState, oldValue: IOranoState): Promise<void> {
        if (newValue) {
            this.equipment = await this._VentixService.getRgfAsync(newValue.ecode);
            this.demandePrestations = await this._VentixService.getDPsAsync(newValue.ecode);
        }
    }

    public get groupeEquipementPrincipal(): GroupeEquipement {
        return this.equipment.groupe_equipements.find(ge => ge.est_principal == 'P');
    }

    public get groupeEquipementSecondaire(): GroupeEquipement {
        const allowedGroups = ['EIP', 'ESPN', 'EDR'];

        return this.equipment.groupe_equipements
            .find(ge => ge.est_principal == 'N'
                && allowedGroups.some(g => g == ge.type_groupe)
            );
    }

    public equipment: RgfWithGroupeEquipements = null;
    public demandePrestations: Array<WRHeaderList> = [];
    public priorities = DPPriorities;
    public prestationTypes = DPPrestationTypes;

    @lazyInject(LocalizerService)
    private readonly _localizerService: LocalizerService;

    @lazyInject(injectTypesApi.IGmaoService)
    private readonly _VentixService: IGmaoService;

    @lazyInject(injectTypes.IDialogService)
    private readonly _dialogService: IDialogService;

    @lazyInject(AppContext)
    private readonly _appContext: AppContext;


    public dpHeaders: Array<DataTableHeader> = [
        { text: 'Id', value: 'WoReqNumber' },
        { text: 'Date de création', value: 'WoReqDateEnter' },
        { text: 'Description - Symptôme', value: 'WrTaskTitle' },
        { text: 'Priorité', value: 'WoTskPriority' },
        { text: 'Type de prestation', value: 'JobType' },
        { text: 'Demandé par', value: 'WrOrigLastName' },
        { text: 'Pour le', value: 'WoReqNeedDate' },
        { text: 'Statut', value: 'WoReqStatus' },
    ];
}
